import { queryFetch } from '../api';

interface ValidateTokenResp {
  success: boolean;
  data?: { id?: string };
}

export const validateToken = (type: 'admin' | 'user') =>
  queryFetch<ValidateTokenResp>({
    url: type === 'admin' ? 'admins/validate_token' : 'users/validate_token',
    panel: type === 'admin',
  });
